import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { Copy } from '@grubhubprod/gh-cookbook-react';
import { CookbookCheckboxWrapper } from 'src/components/CookbookCheckboxWrapper/CookbookCheckboxWrapper';
import { CustomLabelWithTooltip } from 'src/components/common/CustomLabelWithTooltip/CustomLabelWithTooltip';

export interface AutomatedWelcomeEmailsProps {
  name: string;
  id: string;
}

export function AutomatedWelcomeEmails({
  name,
  id,
}: AutomatedWelcomeEmailsProps): JSX.Element {
  const { control } = useFormContext();

  return (
    <CookbookCheckboxWrapper
      control={control}
      id={id}
      name={name}
      label={
        <CustomLabelWithTooltip
          color="primaryText"
          labelText="Automated Welcome Emails"
          tooltipInfo={
            <Copy variant="body" color="invertedPrimaryText">
              Disabling the automated welcome emails will require the user to
              manually trigger the email from diner management.
            </Copy>
          }
        />
      }
    />
  );
}
